import { getPromotionToolState } from '@/modules/main/selector';
import { PromotionEventType } from '@/modules/popup/promotiontool/components/PromotionDialog';
import { getDisplayTimeZone } from '@/modules/popup/promotiontool/PromotionUtil';
import { RootState } from '@/store/store';
import { useSelector } from 'react-redux';

export enum PromotionRankfluctuationType {
    NoChange,
    Rising,
    Falling,
}

export const usePromotionTool = () => {
    const {
        EventType,
        EndTimestamp,
        Timezone,
        ConcludeTimeUTC,
        EventRank,
        LastSeenRank,
        // RankCount,
    } = useSelector((state: RootState) => getPromotionToolState(state));
    const displayTimezone = getDisplayTimeZone(Timezone);

    const eventEnded = (): boolean => {
        const timezone = -displayTimezone;
        const timeDifference =
            EndTimestamp * 1000 + timezone * 60 * 60 * 1000 - Date.now();
        return timeDifference < 0;
    };

    const eventConcluded = (): boolean => {
        const timezone = -displayTimezone;
        const timeDifference =
            ConcludeTimeUTC * 1000 + timezone * 60 * 60 * 1000 - Date.now();
        return timeDifference < 0;
    };

    const fluctuationCheck = (): PromotionRankfluctuationType => {
        //Non-participate scenario
        if (LastSeenRank === 0 && EventRank > 0) {
            //Out of ranking range
            // if (EventRank > RankCount) {
            //     console.log('hook:promotiontool:fluctuation:', 'NoChange');
            //     return PromotionRankfluctuationType.NoChange;
            // } else {
            //Inside ranking range
            // console.log('hook:promotiontool:fluctuation:', 'Rising');
            return PromotionRankfluctuationType.Rising;
            // }
        } else {
            //participate scenario
            // console.log(
            //     'hook:promotiontool:fluctuation:LastSeenRank:',
            //     LastSeenRank
            // );
            // console.log(
            //     'hook:promotiontool:fluctuation:EventRank:',
            //     EventRank
            // );
            if (LastSeenRank - EventRank === 0) {
                // console.log('hook:promotiontool:fluctuation:', 'NoChange');
                return PromotionRankfluctuationType.NoChange;
            } else {
                const fluctuation =
                    LastSeenRank - EventRank > 0
                        ? PromotionRankfluctuationType.Rising
                        : PromotionRankfluctuationType.Falling;
                // console.log(
                //     'hook:promotiontool:fluctuation:',
                //     PromotionRankfluctuationType[fluctuation]
                // );
                return fluctuation;
            }
        }
    };

    const isLeaderboard = (): boolean => {
        return EventType === PromotionEventType.Leaderboard;
    };
    return {
        eventEnded,
        eventConcluded,
        isLeaderboard,
        fluctuationCheck,
        EventRank,
    };
};
